import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessRegistration = () => {
  return (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
        textAlign: "center",
        backgroundColor: "#f5f5f5", // Light background for better contrast
      }}
    >
      <MDBox
        sx={{
          p: 4,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "500px",
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 80, color: "#45964c", mb: 2 }} />

        <MDTypography variant="h5" fontWeight="bold" color="text.primary">
          Submission Received!
        </MDTypography>

        <MDTypography variant="body1" color="text.secondary" mt={1}>
          Your submission has been successfully received and is now awaiting
          approval. Once your project is approved, you will receive a
          notification via email.
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

export default SuccessRegistration;
